import { Container } from 'react-bootstrap';
import '../assets/scss/hero.scss';
import React, { useEffect, useState } from 'react';
import arrow from '../assets/images/right-arrow-white.svg';
import { Link } from 'gatsby';
import Button from 'react-bootstrap/Button';
import scroll from '../assets/images/scroll.gif';
import calender from '../assets/images/calender-icon.svg';
import Services from './Services';
import Modal from 'react-bootstrap/Modal';
  import { useLocation } from '@reach/router';
import { reportConversion } from '../util/gtag';

function Hero({
  isScrollAnimationPresent,
  headerText,
  subHeading,
}: {
  isScrollAnimationPresent?: boolean;
  headerText: string;
  subHeading: string;
}) {
  const scrollToSection = () => {
    window.scrollBy({ top: 500, behavior: 'smooth' });
  };
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


const location = useLocation();
const isVisualPage = location.pathname === '/visual-feedback/';

  return (
    <div
      className={`${isScrollAnimationPresent ? 'hero-section vh-100' : 'hero-section vh-60'} d-flex justify-content-center align-items-center`}
    >
      <Container className="h-100">
        <div className={`d-flex flex-column justify-content-between align-items-center text-center h-100 ${isVisualPage ? 'pt-25' : ''}`}>

          <div className="h-50 d-flex flex-column justify-content-end mt-8 ">
            <div className="text-white d-flex flex-column justify-content-center align-items-center">
              <div className="fw-600 heading-hero-section">{headerText}</div>
              <div className="sub-heading-hero-section mt-3">{subHeading}</div>
            </div>

            <div className="d-flex gap-6 justify-content-center align-items-center mt-4">
              <div className="me-3">
                <Link
                  to={`${process.env.GATSBY_APP_URL}/registration/`}
                  target="_blank"
                >
                  <Button onClick={reportConversion} size="lg" className="font-14 fw-500 no-hover-effect start-for-free-button" >
                    Start for free
                    <img src={arrow} alt="arrow" className="ms-2" />
                  </Button>
                </Link>
              </div>
              <div className="">
                <Link to="https://calendly.com/bugs-work/30min" target="_blank">
                  <Button
                    onClick={reportConversion}
                    size="lg"
                    className="font-14 fw-500 btn-contact-us"
                  >
                    <div className="text-white d-flex justify-content-center align-items-center">
                      <img src={calender} alt="video Icon" className="me-2" />
                      <div className="book-a-demo">Book a demo</div>
                    </div>
                  </Button>
                </Link>
              </div>
            </div>
            <div className="mt-4">
              <button
                className="btn btn-lg font-16 fw-bold rounded-5 learn-quickly-button base-color"
                onClick={handleShow}
              >
                Watch 4-min Explainer Video
              </button>


            </div>
          </div>
          <div className="pb-2 w-100">
            {isScrollAnimationPresent && (
              <>
                <Services />
                <img
                  src={scroll}
                  onClick={scrollToSection}
                  className="scroll-gif  cursor-pointer mt-2 mt-lg-0"
                />
              </>
            )}
          </div>
        </div>
        <Modal show={showModal} onHide={handleClose} size="xl" centered fullscreen="true" className='custom-modal-dialogue'>
          <Modal.Header closeButton>
            <Modal.Title>bugs.work - Video Guide</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe
              width="100%"
              height="700px"
              src="https://www.loom.com/embed/8c1d7451459d4217a0284b95711e32ff?sid=18e01f36-b698-42a0-a8f6-6e5332f3072a"
            ></iframe>
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );
}

export default Hero;
